import React from "react"
import ContentTerms from "../components/ContentTerms"

const About = () => {
  
  return <ContentTerms />
}

export default About
